














export default {
    name: "InputField",
    props: {
        label: String,
    },
};
